import Modal from './confirm';

function getModalInstance({render = undefined, closable} = {}) {
    return Modal.newInstance({
        render,
        closable
    });
}

function confirm(options) {
    const render = ('render' in options) ? options.render : undefined;
    const instance = getModalInstance({render, closable:options.closable})
    instance.show(options)
}

Modal.info = function(props = {}) {
    const props_c = {...props} 
    props_c.icon = 'mdi-information';
    props_c.modal_type = 'info'
    props_c.showCancel = false;
    props_c.visible = true
    props_c.icon_color = 'primary'
    return confirm(props_c);
};

Modal.success = function(props = {}) {
    const props_c = {...props} 
    props_c.icon = 'mdi-check-circle';
    props_c.modal_type = 'success'
    props_c.showCancel = false;
    props_c.visible = true
    props_c.icon_color = 'success'
    return confirm(props_c);
};

Modal.warning = function(props = {}) {
    const props_c = {...props} 
    props_c.icon = 'mdi-alert-circle';
    props_c.modal_type = 'warning'
    props_c.showCancel = false;
    props_c.visible = true
    props_c.icon_color = 'warning'
    return confirm(props_c);
};

Modal.error = function(props = {}) {
    const props_c = {...props} 
    props_c.icon = 'mdi-close-circle';
    props_c.modal_type = 'error'
    props_c.showCancel = false;
    props_c.visible = true
    props_c.icon_color = 'error'
    return confirm(props_c);
};

Modal.confirm = function(props = {}) {
    const props_c = {...props} 
    props_c.icon = 'mdi-help-circle';
    props_c.modal_type = 'confirm'
    props_c.showCancel = props_c.showCancel !== undefined ? props_c.showCancel : true;
    props_c.visible = true
    props_c.icon_color = 'warning'
    return confirm(props_c);
};

export default Modal;